// =============================================
// src/components/Header.jsx
// =============================================

import React from "react";
import { Brain, ChevronDown, Database, Download, LogOut, Settings, Sparkles, User } from "lucide-react";
import HeroDecor from "./HeroDecor";
import { styles } from "../utils/constants";

export default function Header({ isLoggedIn, setIsLoggedIn, setShowUserMenu, showUserMenu }) {
  return (
    <div style={styles.header}>
      <HeroDecor />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", flexWrap: "wrap", gap: "20px", position: "relative", zIndex: 1 }}>
        <div>
          <h1 style={styles.title}>
            <Brain size={32} /> <span>AlzTxPILOT</span>
          </h1>
          <p style={styles.subtitle}>An agentic AI system for drug target prioritization and repurposing in Alzheimer's disease</p>
        </div>
        <div style={{ position: "relative", flex: "0 0 auto" }}>
          {isLoggedIn ? (
            <UserMenu setIsLoggedIn={setIsLoggedIn} showUserMenu={showUserMenu} setShowUserMenu={setShowUserMenu} />
          ) : (
            <button
              style={{
                padding: "8px 20px",
                borderRadius: "8px",
                backgroundColor: "rgba(255,255,255,0.2)",
                border: "2px solid rgba(255,255,255,0.3)",
                color: "white",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                marginRight: "32px",
                marginTop: "18px",
              }}
              onClick={() => setIsLoggedIn(true)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
              }}
            >
              <User size={16} /> Sign In
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function UserMenu({ setIsLoggedIn, showUserMenu, setShowUserMenu }) {
  return (
    <>
      <button
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          backgroundColor: "#ffffff",
          border: "2px solid rgba(255,255,255,0.3)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 18,
          fontWeight: 600,
          color: "#0891b2",
          transition: "all 0.2s ease",
        }}
        onClick={() => setShowUserMenu(!showUserMenu)}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
        }}
      >
        <User size={20} color="#0891b2" />
        <div style={{ position: "absolute", bottom: -2, right: -2, width: 10, height: 10, backgroundColor: "#0891b2", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <ChevronDown size={8} color="white" />
        </div>
      </button>

      {showUserMenu && (
        <div
          style={{
            position: "fixed",
            top: 50,
            right: "clamp(16px, calc((100vw - 1200px)/2 + 16px), 80px)",
            width: "min(320px, 92vw)",
            backgroundColor: "white",
            borderRadius: 12,
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
            minWidth: 220,
            padding: 8,
            zIndex: 10000,
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ padding: "12px 16px", borderBottom: "1px solid #e2e8f0", marginBottom: 8, position: "relative", zIndex: 10, background: "white" }}>
            <p style={{ margin: "0 0 4px 0", fontSize: 14, fontWeight: 600, color: "#0f172a" }}>User Name</p>
            <p style={{ margin: 0, fontSize: 12, color: "#64748b" }}>user@example.com</p>
          </div>

          {[
            { icon: <Database size={16} />, label: "My Queries" },
            { icon: <Download size={16} />, label: "My Downloads" },
            { icon: <Sparkles size={16} />, label: "Manage Live Modes" },
            { icon: <Settings size={16} />, label: "Account Settings" },
          ].map((item) => (
            <button
              key={item.label}
              style={{
                width: "100%",
                padding: "10px 16px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: 8,
                textAlign: "left",
                fontSize: 14,
                color: "#334155",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f1f5f9")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              {item.icon}
              {item.label}
            </button>
          ))}

          <div style={{ borderTop: "1px solid #e2e8f0", marginTop: 8, paddingTop: 8 }}>
            <button
              style={{
                width: "100%",
                padding: "10px 16px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: 8,
                textAlign: "left",
                fontSize: 14,
                color: "#dc2626",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#fef2f2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
              onClick={() => setIsLoggedIn(false)}
            >
              <LogOut size={16} /> Sign Out / Close Menu
            </button>
          </div>
        </div>
      )}
    </>
  );
}



